import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrl } from '../../config/api';
import { RootState } from '../index';

export interface SynthflowAccount {
  id: number;
  name: string;
}


export const synthflowApi = createApi({
  reducerPath: 'synthflowApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/api/v1/synthflow-accounts'),
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['SynthflowAccount'],
  endpoints: (builder) => ({
    getActiveSynthflowAccounts: builder.query<SynthflowAccount[], void>({
      query: () => '/active',
      providesTags: ['SynthflowAccount'],
    }),
    syncSynthflowAccounts: builder.mutation<{ message: string; stats: any }, void>({
      query: () => ({
        url: '/sync',
        method: 'POST',
      }),
      invalidatesTags: ['SynthflowAccount'],
    }),
  }),
});

export const {
  useGetActiveSynthflowAccountsQuery,
  useSyncSynthflowAccountsMutation,
} = synthflowApi;
